
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {PermissionsGroup} from '@/store/models.def';
import {getTableName} from '@/worker/db/sqlHelpers';
import IncludeUnappliedToggle from '@/components/IncludeUnappliedToggle.vue';
import settingx from '@/store/modules/settingx';

@Component({
	components: {
		AmountDisplayerFilterable,
		IncludeUnappliedToggle,
	},
})
export default class CustomerTotalOutstandingNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['customers'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['customers', 'agents', 'dateAsOf'];

	public amount: number = 0;

	public get includeUnapplied() {
		return settingx.now.includeUnapplied;
	}

	public get expensiveHook() {
		const { selectedAsOfDate, selectedAgents, selectedCustomers, includeUnapplied } = this;
		return JSON.stringify([
			selectedAsOfDate,
			selectedAgents,
			selectedCustomers,
			includeUnapplied,
		]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const table = getTableName('customerTrades');

		let customerFilter = '';
		if (this.selectedCustomers.length > 0) {
			const list = this.selectedCustomers.map((c) => `'${escapeStr(c)}'`).join(',');
			customerFilter = ` AND "CODE" IN (${list})`;
		}
		let agentFilter = '';
		if (this.selectedAgents.length > 0) {
			const list = this.selectedAgents.map((a) => `'${escapeStr(a)}'`).join(',');
			agentFilter = ` AND "AGENT" IN (${list})`;
		}

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['customerTrades']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT
				SUM(CASE WHEN "DOCTYPE" IN ('IV','DN') THEN TRY_CAST("LOCALOSAMOUNT" AS DOUBLE) ELSE 0 END) as os_amt,
				SUM(CASE WHEN "DOCTYPE" IN ('CN','CT','DP','PM') THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as minus_unapplied,
				SUM(CASE WHEN "DOCTYPE" = 'CF' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as plus_unapplied
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				${customerFilter}${agentFilter}
		`);
		this.checkInterrupted(jobId);

		const osAmount = Number(result[0] && result[0].os_amt) || 0;
		if (this.includeUnapplied) {
			const minusUnapplied = Number(result[0] && result[0].minus_unapplied) || 0;
			const plusUnapplied = Number(result[0] && result[0].plus_unapplied) || 0;
			this.amount = osAmount - minusUnapplied + plusUnapplied;
		} else {
			this.amount = osAmount;
		}

		this.generateLoadingText(1);
		this.saveHistory('amount');
	}
}
